import type {ActivePreset, PresetDetail} from '../types/Api';

export const isPresetCustom = (preset: ActivePreset): preset is PresetDetail =>
  'title' in preset || 'description' in preset;
